export const DEAL_OVERVIEW = 'Overview';
export const BACK_OF_ENVELOPE = 'Back-Of-Envelope';
export const DEAL_ACTIVITY = 'Activity';

export const DEAL_OVERVIEW_TABS = [DEAL_OVERVIEW, BACK_OF_ENVELOPE, DEAL_ACTIVITY];

export const TAB_TO_SLUG: Record<string, string> = {
    [DEAL_OVERVIEW]: 'overview',
    [BACK_OF_ENVELOPE]: 'backofenvelope',
    [DEAL_ACTIVITY]: 'activity',
};

export const SLUG_TO_TAB: Record<string, string> = {
    overview: DEAL_OVERVIEW,
    backofenvelope: BACK_OF_ENVELOPE,
    activity: DEAL_ACTIVITY,
};

/* eslint-disable no-unused-vars */
export enum ExportOptions {
    DEAL_OVERVIEW = 'Deal overview',
    SCENARIO_DASHBOARD = 'Back-of-envelope',
}

export const CRM_ENTITY_TYPE = {
    CONTACT: 'contact',
    COMPANY: 'company',
    ACTIVITY: 'activity',
    PROJECT: 'project',
    DEAL: 'deal',
} as const;

export const projectIconFallback = 'default_project_picture_icons/1_256.png' as const;
export const ACTIVITY_TYPE = {
    MEETING: 'Meeting',
    EMAIL: 'Email',
    NOTE: 'Note',
} as const;

export const TEMP_TIMELINE_ID_PREFIX = 'temp-';

export enum DateField {
    TARGET = 'target',
    COMPLETED = 'completed'
}

export enum TimelineStatus {
    OPEN = 'open',
    COMPLETE = 'complete',
    OVERDUE = 'overdue'
}

export const TimelineStatusBootstrapColorMap: Record<TimelineStatus, string> = {
    [TimelineStatus.OPEN]: 'primary-lighten',
    [TimelineStatus.COMPLETE]: 'success-lighten',
    [TimelineStatus.OVERDUE]: 'danger-lighten',
};
